<template>
  <div class="moments-list" v-if="moments.length > 0">
    <div class="moments-content">
      <div class="moments-row">
        <div class="moments-header">
          <i class="fas fa-comment-dots"></i>
          <span>最新说说:</span>
        </div>
        <transition name="fade" mode="out-in">
          <div class="moment-item" :key="currentIndex">
            <span class="moment-text" @click="goToMoments" v-html="moments[currentIndex].content" />
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
// import { getMoments } from '@/api/moments'

export default {
  name: 'MomentsList',
  data() {
    return {
      moments: [
        {
          content: '今天天气真好，适合出去走走~ 🌞',
          id: 1
        },
        {
          content: '分享一首好听的歌：周杰伦 - 晴天 🎵',
          id: 2
        },
        {
          content: '学习Vue3的新特性，感觉很不错！ 💻',
          id: 3
        },
        {
          content: '今天完成了博客的新功能开发，开心 😊',
          id: 4
        },
        {
          content: '推荐一本好书：《JavaScript高级程序设计》 📚',
          id: 5
        }
      ],
      currentIndex: 0,
      timer: null
    }
  },
  created() {
    // this.getMomentsList()
    this.startRotation()
  },
  mounted() {
    this.startRotation()
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer)
    }
  },
  methods: {
    getMomentsList() {
      getMoments({ pageSize: 5, pageNum: 1 }).then(res => {
        if (res.data && res.data.records) {
          this.moments = res.data.records
          this.startRotation()
        }
      })
    },
    goToMoments() {
      this.$router.push('/moments')
    },
    startRotation() {
      if (this.timer) {
        clearInterval(this.timer)
      }
      this.timer = setInterval(() => {
        this.currentIndex = (this.currentIndex + 1) % this.moments.length
      }, 4000) // 每4秒切换一次
    }
  }
}
</script>

<style lang="scss" scoped>
.moments-list {
  background: var(--background-color);
  border-radius: 12px;
  padding: 15px 20px;
  margin-bottom: 20px;
  // box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.moments-content {
  .moments-row {
    display: flex;
    align-items: center;
    gap: 10px;
  }
}

.moments-header {
  display: flex;
  align-items: center;
  gap: 10px;
  color: var(--text-color);
  font-weight: 500;
  white-space: nowrap;
  
  i {
    color: var(--theme-color);
    font-size: 1.2em;
  }
}

.moment-item {
  flex: 1;
  display: flex;
  align-items: center;
  min-width: 0;
  max-height: 20px;
  overflow: hidden;
  .moment-text {
    color: var(--text-color);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
    cursor: pointer;
    &:hover {
      color: var(--theme-color);
    }
  }
}

// 添加过渡动画样式
.fade-enter-active,
.fade-leave-active {
  transition: all 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
  transform: translateY(10px);
}

.fade-enter-to,
.fade-leave-from {
  opacity: 1;
  transform: translateY(0);
}
</style> 